module.exports = __webpack_public_path__ + "static/img/unconscious-bias.5fc0d73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/research-page/unconscious-bias.png
// module id = sSzR
// module chunks = 0